import { getRootDomain } from '@constants/subdomains'
import type { ThemeMode } from '@app-types/stores/theme'

const themeCookieKey = 'spa_theme_mode'

function isThemeMode(value: unknown): value is ThemeMode {
  return value === 'light' || value === 'dark'
}

function cookieRootDomain() {
  const hostname = globalThis.location.hostname.toLowerCase()
  const rootDomain = getRootDomain().toLowerCase()

  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]'
  ) {
    return ''
  }

  if (hostname === rootDomain || hostname.endsWith(`.${rootDomain}`)) {
    return rootDomain
  }

  const parts = hostname.split('.')

  return parts.length > 2 ? parts.slice(-2).join('.') : ''
}

export function readThemeCookie() {
  const cookie = globalThis.document.cookie
    .split('; ')
    .find((item) => item.startsWith(`${themeCookieKey}=`))

  if (!cookie) {
    return null
  }

  try {
    const mode = decodeURIComponent(cookie.split('=')[1] ?? '')

    return isThemeMode(mode) ? mode : null
  } catch {
    return null
  }
}

export function saveThemeCookie(mode: ThemeMode) {
  const rootDomain = cookieRootDomain()
  const secure = globalThis.location.protocol === 'https:' ? '; Secure' : ''
  const domain = rootDomain ? `; Domain=.${rootDomain}` : ''

  globalThis.document.cookie = `${themeCookieKey}=${encodeURIComponent(
    mode,
  )}; Max-Age=31536000; Path=/; SameSite=Lax${domain}${secure}`
}

export function syncRootThemeClass(mode: ThemeMode) {
  globalThis.document.documentElement.classList.toggle('dark', mode === 'dark')
}
